import { useEffect, useRef, useState } from 'react';
import EmojiPicker from 'emoji-picker-react';
import avatar from '../../assets/images/avatar.png';
import { useDispatch } from 'react-redux';
import { getUserById, sendMessage } from '../../redux/Chat/chatAction';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { toast } from 'react-toastify';

const ChatDetails = ({ selectedChat, setChatMob }) => {
    const dispatch = useDispatch();
    const { userData } = useSelector((state) => state.user);
    const emojiRef = useRef(null);

    const { isGettingMessages, messages, isSendingMessage } = useSelector(
        (state) => state.chat
    );

    const [emojiToggle, setEmojiToggle] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [chatPayload, setChatPayload] = useState({
        message: '',
    });

    const [user, setUser] = useState(null);
    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        setTimeout(() => {
            messagesEndRef.current?.scrollIntoView();
        }, 500);
    };

    const handleInputs = (e) => {
        const { name, value } = e.target;
        setChatPayload((prev) => ({ ...prev, [name]: value }));
    };

    const handleEmoji = (emojiObject) => {
        setChatPayload((prevState) => ({
            ...prevState,
            message: prevState.message + emojiObject.emoji,
        }));
        setEmojiToggle(!emojiToggle);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            if (
                file.type.startsWith('image/') ||
                file.type.startsWith('video/')
            ) {
                if (file.type.startsWith('image/') && file.size > 1024 * 1024) {
                    // Max size for image: 1MB
                    toast.warning('Image size should be maximum 1MB');
                    return;
                } else if (
                    file.type.startsWith('video/') &&
                    file.size > 5 * 1024 * 1024
                ) {
                    toast.warning('Video size should be maximum 5MB');
                    return;
                } else {
                    setSelectedFile(file);
                }
            } else {
                toast.warning('Please select only image or video');
            }
            //   const reader = new FileReader();

            //   reader.onload = (e) => {
            //     setSelectedFile(e.target.result);
            //   };

            //   reader.readAsDataURL(file);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let obj = {
            ...chatPayload,
            senderId: userData?.id,
            messageType: 'text',
        };
        let attachmentType = '';

        if (chatPayload.message && selectedFile) {
            attachmentType = selectedFile.type.startsWith('video/')
                ? 'video'
                : 'image';
            obj = {
                ...obj,
                messageType: 'both',
                attachment: selectedFile,
                attachmentType,
            };
        } else if (selectedFile) {
            attachmentType = selectedFile.type.startsWith('video/')
                ? 'video'
                : 'image';
            obj = {
                ...obj,
                messageType: 'media',
                attachment: selectedFile,
                attachmentType,
            };
        }
        dispatch(
            sendMessage(selectedChat, obj, () => {
                setChatPayload({
                    message: '',
                });
                setSelectedFile(null);
            })
        );
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    // const formatDate = (timestamp) => {
    //   if (!timestamp) return null;

    //   const createdAt = moment.unix(timestamp.seconds);
    //   const today = moment().startOf("day");
    //   const yesterday = moment().subtract(1, "days").startOf("day");

    //   if (createdAt.isSame(today, "d")) {
    //     return "Today";
    //   } else if (createdAt.isSame(yesterday, "d")) {
    //     return "Yesterday";
    //   } else {
    //     return createdAt.format("MMM DD, YYYY");
    //   }
    // };
    const formatDate = (dateString) => {
        const date = moment(dateString, 'DD/MM/YYYY');
        const today = moment().startOf('day');
        const yesterday = moment().subtract(1, 'days').startOf('day');

        if (date.isSame(today, 'd')) {
            return 'Today';
        } else if (date.isSame(yesterday, 'd')) {
            return 'Yesterday';
        } else {
            return date.format('DD/MM/YYYY');
        }
    };
    useEffect(() => {
        function handleClickOutside(event) {
            if (emojiRef.current && !emojiRef.current.contains(event.target)) {
                setEmojiToggle(false);
            }
        }

        // Add event listener to detect clicks outside of the emoji picker
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            // Cleanup the event listener when the component is unmounted
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (
        <div className="chat-details border rounded-end-4">
            {isGettingMessages ? (
                <div className="d-flex justify-content-center align-items-center">
                    <Spin className="pt-40 pb-40" />
                </div>
            ) : (
                <>
                    {selectedChat ? (
                        <>
                            <div>
                                <div className="d-flex align-items-center gap-2 py-4 px-5">
                                    <div
                                        className="d-flex d-md-none border bg-white px-2 py-1 rounded-circle cp"
                                        onClick={() => {
                                            setChatMob(false);
                                        }}
                                    >
                                        <svg
                                            width="8"
                                            height="15"
                                            viewBox="0 0 8 15"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M6.87702 14.3307L0.496813 7.95045C0.437492 7.8912 0.390432 7.82083 0.358325 7.74338C0.326216 7.66592 0.309691 7.5829 0.309691 7.49905C0.309691 7.41521 0.326216 7.33218 0.358325 7.25473C0.390432 7.17727 0.437492 7.10691 0.496813 7.04765L6.87702 0.667445C6.99674 0.547726 7.15911 0.480469 7.32842 0.480469C7.49773 0.480469 7.6601 0.547726 7.77982 0.667445C7.89954 0.787163 7.9668 0.949537 7.9668 1.11884C7.9668 1.28815 7.89954 1.45053 7.77982 1.57024L1.85022 7.49905L7.77982 13.4279C7.8391 13.4871 7.88612 13.5575 7.9182 13.635C7.95029 13.7124 7.9668 13.7954 7.9668 13.8793C7.9668 13.9631 7.95029 14.0461 7.9182 14.1236C7.88612 14.201 7.8391 14.2714 7.77982 14.3307C7.72054 14.3899 7.65017 14.437 7.57272 14.469C7.49527 14.5011 7.41225 14.5176 7.32842 14.5176C7.24459 14.5176 7.16158 14.5011 7.08413 14.469C7.00667 14.437 6.9363 14.3899 6.87702 14.3307Z"
                                                fill="#667085"
                                            />
                                        </svg>
                                    </div>
                                    <img
                                        className="rounded-circle mr-2"
                                        src={
                                            selectedChat?.chatWithDetails
                                                ?.profile_photo_path || avatar
                                        }
                                        alt="avatar"
                                        width={64}
                                        height={64}
                                    />
                                    <div className="d-flex flex-column">
                                        <h5 className="heading">
                                            {
                                                selectedChat?.chatWithDetails
                                                    ?.name
                                            }
                                        </h5>
                                        {/* <div className="d-flex gap-1">
                      <div className="call">
                        <svg
                          width="11"
                          height="10"
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.57042 9.60603C8.50382 9.60603 7.45002 9.3736 6.40902 8.90873C5.36802 8.44386 4.42088 7.78462 3.56761 6.931C2.71433 6.07738 2.05526 5.13024 1.59039 4.08959C1.12552 3.04893 0.892919 1.99513 0.892578 0.92819C0.892578 0.7746 0.943775 0.646608 1.04617 0.544215C1.14856 0.441822 1.27655 0.390625 1.43014 0.390625H3.50361C3.62307 0.390625 3.72973 0.431241 3.82359 0.512473C3.91745 0.593705 3.97291 0.689614 3.98998 0.800199L4.32276 2.59208C4.33982 2.72861 4.33556 2.8438 4.30996 2.93766C4.28436 3.03152 4.23743 3.11258 4.16917 3.18084L2.92765 4.43516C3.0983 4.75088 3.30087 5.05584 3.53535 5.35005C3.76983 5.64426 4.02803 5.92806 4.30996 6.20145C4.57447 6.46597 4.85179 6.71137 5.1419 6.93766C5.43202 7.16395 5.7392 7.37078 6.06344 7.55816L7.26657 6.35504C7.34336 6.27824 7.44371 6.22073 7.5676 6.18251C7.6915 6.14428 7.81301 6.13353 7.93212 6.15025L9.69841 6.50863C9.81787 6.54276 9.916 6.60471 9.99279 6.69447C10.0696 6.78424 10.108 6.88441 10.108 6.995V9.06847C10.108 9.22206 10.0568 9.35005 9.95439 9.45244C9.852 9.55483 9.72401 9.60603 9.57042 9.60603Z"
                            fill="#C42126"
                          />
                        </svg>
                      </div>
                      <div className="call">
                        <svg
                          width="13"
                          height="8"
                          viewBox="0 0 13 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.13709 0.691406C1.30158 0.691406 0.120117 1.07562 0.120117 1.38563V6.59872C0.120117 6.90164 1.30158 7.30759 4.13709 7.30759C6.9726 7.30759 8.15406 6.92338 8.15406 6.61337V1.40028C8.15406 1.09736 6.9726 0.691406 4.13709 0.691406ZM12.112 0.706056C12.0325 0.709222 11.9556 0.734959 11.8903 0.780252L8.81852 2.75897C8.70037 2.84781 8.62665 2.99431 8.62665 3.14318V4.85582C8.62665 5.00469 8.70037 5.15072 8.81852 5.24004L11.8903 7.21922C11.9735 7.28208 12.378 7.47914 12.378 6.83501V1.16399C12.378 0.792067 12.25 0.700385 12.112 0.706056Z"
                            fill="#C42126"
                          />
                        </svg>
                      </div>
                    </div> */}
                                    </div>
                                </div>
                                {messages?.length == 0 && (
                                    <div className="d-flex justify-content-center ">
                                        <p className="subheading mb-0">
                                            You joined this chat
                                        </p>
                                    </div>
                                )}

                                <div className="msgsCont">
                                    {messages?.map((group, idx) => {
                                        return (
                                            <div key={idx}>
                                                <div className="chat-sticky-date">
                                                    {group?.date !=
                                                        'Invalid date' && (
                                                        <p className="subheading">
                                                            {' '}
                                                            {formatDate(
                                                                group?.date
                                                            )}
                                                        </p>
                                                    )}
                                                </div>

                                                {group?.groupedMessages.map(
                                                    (item, index) => {
                                                        return (
                                                            <>
                                                                <div
                                                                    // className={`mb-3 d-flex  ${
                                                                    //   item.senderId == userData?.id
                                                                    //     ? "justify-content-end"
                                                                    //     : "justify-content-start"
                                                                    // }`}
                                                                    className={`mb-3 d-flex flex-column  ${
                                                                        item.senderId ==
                                                                        userData?.id
                                                                            ? 'align-items-end'
                                                                            : 'align-items-start '
                                                                    }`}
                                                                    key={index}
                                                                >
                                                                    {(item?.messageType ==
                                                                        'media' ||
                                                                        item?.messageType ==
                                                                            'both') && (
                                                                        <div className="chat-details-media mb-3">
                                                                            {item?.attachmentType ==
                                                                            'video' ? (
                                                                                <video
                                                                                    src={
                                                                                        item?.attachment
                                                                                    }
                                                                                    className="chat-media"
                                                                                    controls
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src={
                                                                                        item?.attachment
                                                                                    }
                                                                                    className="chat-media"
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    <div
                                                                        className={`chart-card ${
                                                                            item.senderId ==
                                                                            userData?.id
                                                                                ? 'sender-item'
                                                                                : 'receiver-item'
                                                                        }`}
                                                                    >
                                                                        {(item?.messageType ==
                                                                            'text' ||
                                                                            item?.messageType ==
                                                                                'both') && (
                                                                            <p className="chatText mb-1">
                                                                                {
                                                                                    item?.message
                                                                                }
                                                                            </p>
                                                                        )}
                                                                        {/* {(item?.messageType == "media" ||
                                    item?.messageType == "both") && (
                                    <div>
                                      {item?.attachmentType == "video" ? (
                                        <video
                                          src={item?.attachment}
                                          className="chat-media"
                                          controls
                                        />
                                      ) : (
                                        <img
                                          src={item?.attachment}
                                          className="chat-media"
                                        />
                                      )}
                                    </div>
                                  )} */}
                                                                        <div className="d-flex justify-content-end align-items-center">
                                                                            <span className="time me-1">
                                                                                {item
                                                                                    ?.createdAt
                                                                                    ?.seconds &&
                                                                                    moment
                                                                                        .unix(
                                                                                            item
                                                                                                ?.createdAt
                                                                                                .seconds
                                                                                        )
                                                                                        .format(
                                                                                            'hh:mm A'
                                                                                        )}
                                                                            </span>
                                                                            <svg
                                                                                width="12"
                                                                                height="8"
                                                                                viewBox="0 0 12 8"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M1.33301 4.525L3.16642 6.625L7.74967 1.375M10.6663 1.41175L5.66601 6.66175L5.41634 6.33333"
                                                                                    stroke="black"
                                                                                    stroke-width="0.875"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        );
                                    })}

                                    <div ref={messagesEndRef} />
                                </div>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="messageBox">
                                    {selectedFile && (
                                        <div className="d-flex align-items-center mx-1   selected-file">
                                            <span>
                                                {selectedFile?.name.substring(
                                                    0,
                                                    10
                                                )}
                                                ...
                                            </span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 352 512"
                                                fill="red"
                                                height="20px"
                                                width="20px"
                                                className="cp"
                                                onClick={() => {
                                                    if (!isSendingMessage) {
                                                        setSelectedFile(null);
                                                    }
                                                }}
                                            >
                                                <path d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.5c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z" />
                                            </svg>
                                        </div>
                                    )}
                                    <div className="d-flex align-items-center justify-content-center bg-white w-100">
                                        <div className="position-relative">
                                            <svg
                                                onClick={() =>
                                                    setEmojiToggle(!emojiToggle)
                                                }
                                                className="mx-2 cp"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M21.6004 11.9984C21.6004 9.45236 20.589 7.01056 18.7886 5.21021C16.9883 3.40986 14.5465 2.39844 12.0004 2.39844C9.45431 2.39844 7.01252 3.40986 5.21217 5.21021C3.41182 7.01056 2.40039 9.45236 2.40039 11.9984C2.40039 14.5445 3.41182 16.9863 5.21217 18.7867C7.01252 20.587 9.45431 21.5984 12.0004 21.5984C14.5465 21.5984 16.9883 20.587 18.7886 18.7867C20.589 16.9863 21.6004 14.5445 21.6004 11.9984ZM3.60039 11.9984C3.60039 10.8953 3.81766 9.80303 4.2398 8.7839C4.66194 7.76476 5.28068 6.83875 6.06069 6.05874C6.84071 5.27873 7.76672 4.65999 8.78585 4.23785C9.80499 3.81571 10.8973 3.59844 12.0004 3.59844C13.1035 3.59844 14.1958 3.81571 15.2149 4.23785C16.2341 4.65999 17.1601 5.27873 17.9401 6.05874C18.7201 6.83875 19.3388 7.76476 19.761 8.7839C20.1831 9.80303 20.4004 10.8953 20.4004 11.9984C20.4004 14.2263 19.5154 16.3628 17.9401 17.9381C16.3648 19.5134 14.2282 20.3984 12.0004 20.3984C9.77257 20.3984 7.636 19.5134 6.06069 17.9381C4.48539 16.3628 3.60039 14.2263 3.60039 11.9984ZM16.2004 10.1984C16.2004 9.88018 16.074 9.57495 15.8489 9.34991C15.6239 9.12487 15.3187 8.99844 15.0004 8.99844C14.6821 8.99844 14.3769 9.12487 14.1519 9.34991C13.9268 9.57495 13.8004 9.88018 13.8004 10.1984C13.8004 10.5167 13.9268 10.8219 14.1519 11.047C14.3769 11.272 14.6821 11.3984 15.0004 11.3984C15.3187 11.3984 15.6239 11.272 15.8489 11.047C16.074 10.8219 16.2004 10.5167 16.2004 10.1984ZM10.2004 10.1984C10.2004 9.88018 10.074 9.57495 9.84892 9.34991C9.62388 9.12487 9.31865 8.99844 9.00039 8.99844C8.68213 8.99844 8.37691 9.12487 8.15186 9.34991C7.92682 9.57495 7.80039 9.88018 7.80039 10.1984C7.80039 10.5167 7.92682 10.8219 8.15186 11.047C8.37691 11.272 8.68213 11.3984 9.00039 11.3984C9.31865 11.3984 9.62388 11.272 9.84892 11.047C10.074 10.8219 10.2004 10.5167 10.2004 10.1984ZM8.26719 15.0164C8.21763 14.9551 8.15648 14.9042 8.08723 14.8665C8.01799 14.8289 7.942 14.8052 7.86361 14.7969C7.78521 14.7886 7.70596 14.7958 7.63035 14.8181C7.55475 14.8405 7.48429 14.8775 7.42299 14.927C7.36169 14.9766 7.31075 15.0377 7.27308 15.107C7.23541 15.1762 7.21175 15.2522 7.20345 15.3306C7.19515 15.409 7.20237 15.4883 7.2247 15.5639C7.24703 15.6395 7.28403 15.7099 7.33359 15.7712C7.89619 16.4669 8.60726 17.028 9.41474 17.4134C10.2222 17.7988 11.1057 17.9986 12.0004 17.9984C13.8844 17.9984 15.568 17.1284 16.6672 15.7712C16.7168 15.7099 16.7539 15.6395 16.7763 15.5638C16.7987 15.4882 16.806 15.4089 16.7978 15.3304C16.7895 15.252 16.7659 15.1759 16.7283 15.1066C16.6906 15.0373 16.6397 14.9761 16.5784 14.9264C16.5171 14.8768 16.4466 14.8397 16.371 14.8173C16.2954 14.7949 16.216 14.7876 16.1376 14.7959C16.0592 14.8041 15.9831 14.8277 15.9138 14.8654C15.8445 14.903 15.7832 14.9539 15.7336 15.0152C15.2837 15.572 14.7149 16.0212 14.069 16.3297C13.423 16.6382 12.7162 16.7984 12.0004 16.7984C11.2846 16.7985 10.5779 16.6386 9.93197 16.3302C9.28603 16.0219 8.71722 15.573 8.26719 15.0164Z"
                                                    fill="black"
                                                />
                                            </svg>
                                            {emojiToggle && (
                                                <div
                                                    className="position-absolute"
                                                    style={{
                                                        bottom: 45,
                                                        left: 0,
                                                    }}
                                                    ref={emojiRef}
                                                >
                                                    <EmojiPicker
                                                        // open={emojiToggle}
                                                        onEmojiClick={
                                                            handleEmoji
                                                        }
                                                    />{' '}
                                                </div>
                                            )}
                                        </div>
                                        <input
                                            className="chat-input"
                                            placeholder="Type message here"
                                            name="message"
                                            value={chatPayload.message}
                                            onChange={handleInputs}
                                            disabled={isSendingMessage}
                                            // required={selectedFile == null}
                                            required
                                        />

                                        <div className="d-flex">
                                            <label htmlFor="fileInput">
                                                <svg
                                                    className="mx-2 cp"
                                                    width="12"
                                                    height="20"
                                                    viewBox="0 0 12 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M4.12871 6.99832V13.7413C4.1365 14.2344 4.33784 14.7046 4.68928 15.0505C5.04073 15.3965 5.51409 15.5904 6.00723 15.5904C6.50036 15.5904 6.97373 15.3965 7.32517 15.0505C7.67661 14.7046 7.87795 14.2344 7.88574 13.7413L7.89183 4.90301C7.89695 4.48157 7.81836 4.06331 7.66062 3.67247C7.50288 3.28163 7.26913 2.92599 6.97292 2.62616C6.6767 2.32634 6.32392 2.08829 5.93503 1.92582C5.54613 1.76335 5.12885 1.67969 4.70738 1.67969C4.28591 1.67969 3.86863 1.76335 3.47974 1.92582C3.09084 2.08829 2.73806 2.32634 2.44185 2.62616C2.14564 2.92599 1.91189 3.28163 1.75415 3.67247C1.59641 4.06331 1.51782 4.48157 1.52293 4.90301V13.8008C1.51434 14.3941 1.62379 14.9833 1.8449 15.5339C2.06602 16.0845 2.39439 16.5857 2.81093 17.0084C3.22747 17.431 3.72386 17.7666 4.27125 17.9956C4.81864 18.2247 5.40611 18.3426 5.99949 18.3426C6.59288 18.3426 7.18034 18.2247 7.72773 17.9956C8.27512 17.7666 8.77151 17.431 9.18805 17.0084C9.60459 16.5857 9.93296 16.0845 10.1541 15.5339C10.3752 14.9833 10.4846 14.3941 10.4761 13.8008V5.48614"
                                                        stroke="black"
                                                        stroke-width="1.5"
                                                        stroke-miterlimit="10"
                                                        stroke-linecap="round"
                                                    />
                                                </svg>
                                            </label>
                                            <input
                                                className="d-none"
                                                type="file"
                                                id="fileInput"
                                                onChange={handleFileChange}
                                                accept="image/*,video/*"
                                            />
                                            {/* {selectedFile && (
                        <div className="d-flex mx-1   selected-file">
                          <span>{selectedFile?.name.substring(0, 5)}..</span>
                          <i className="fa fa-times text-danger cp"></i>
                        </div>
                      )} */}
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        disabled={isSendingMessage}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M20.2346 5.68463C20.6666 4.48963 19.5086 3.33163 18.3136 3.76463L3.70855 9.04663C2.50955 9.48063 2.36455 11.1166 3.46755 11.7556L8.12955 14.4546L12.2926 10.2916C12.4812 10.1095 12.7338 10.0087 12.996 10.011C13.2582 10.0132 13.509 10.1184 13.6944 10.3038C13.8798 10.4892 13.9849 10.74 13.9872 11.0022C13.9895 11.2644 13.8887 11.517 13.7066 11.7056L9.54355 15.8686L12.2436 20.5306C12.8816 21.6336 14.5176 21.4876 14.9516 20.2896L20.2346 5.68463Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center h-full">
                            <p className="subheading">Select chat</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ChatDetails;
